import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Board } from '../../../core/src/shared/enums';
import { SelectBox } from '../molecules/select-box';
import { License } from '../shared';
import { useSelector } from '../store/utils';

export const LicenseSelect = () => {
  const board = useSelector(({ variables }) => variables.BOARD);

  let options = [
    {
      label: (
        <FormattedMessage
          id="test-product.settings.license.basic"
          defaultMessage="Basic"
        />
      ),
      value: License.Basic,
    },
    {
      label: (
        <FormattedMessage
          id="test-product.settings.license.HW"
          defaultMessage="HW"
        />
      ),
      value: License.HW,
    },
    {
      label: (
        <FormattedMessage
          id="test-product.settings.license.Smart"
          defaultMessage="Smart"
        />
      ),
      value: License.SMART,
    },
    {
      label: (
        <FormattedMessage
          id="test-product.settings.license.Industrial"
          defaultMessage="Industrial"
        />
      ),
      value: License.INDUSTRIAL,
    },
  ];

  if (board === Board.Play) {
    options = [
      {
        label: (
          <FormattedMessage
            id="test-product.settings.license.Play"
            defaultMessage="PLAY"
          />
        ),
        value: License.PLAY,
      },
    ];
  }

  return (
    <SelectBox
      title={
        <FormattedMessage
          id="test-product.settings.license"
          defaultMessage="Licence"
        />
      }
      selectVariableId="LICENSE"
      options={options}
      fullWidth
    />
  );
};
